import AddCircleIcon from "@mui/icons-material/AddCircle";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import DeleteIcon from "@mui/icons-material/Delete";
import LinkIcon from "@mui/icons-material/Link";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import SaveIcon from "@mui/icons-material/Save";
import RefreshIcon from "@mui/icons-material/Refresh";
import UpdateIcon from "@mui/icons-material/Update";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import { alpha, Alert, Box, Divider, Fab, FormGroup, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useContext, useEffect, useState, useRef, useTransition } from "react";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import logoLight from "../../assets/logo-pos.png";
import logo from "../../assets/logo.png";
import { environments } from "../../environments";
import {
  ConfigCaracterizacao,
  GenericObject,
  ImobiliarioEdificacao,
  ImobiliarioPessoa,
  Tabelas,
} from "../../interfaces";
import { DashboardContext } from "../../providers/Dashboard";
import { ColorModeContext } from "../../providers/Theme";
import {
  getData,
  getDataStructureByTable,
  getDataStructures,
  getFirstIdLote,
  getForms,
  getPermissoesProjetos,
  getTenantConfig,
  sendLogs,
} from "../../services/api";
import {
  addEdificacaoToImobiliario,
  addPessoaToImobiliario,
  createImobiliario,
  createMensagem,
  createVisita,
  deleteImobiliario, getTokens,
  isIdLoaded,
  patchTipoImpostoTo2,
  removeEdificacaoFromImobiliario,
  removeMensagem,
  removePessoaFromImobiliario,
  removeVisita,
  saveData,
  setLoadedId
} from "../../services/data";
import { clearData, clearLogs, del, getAll, getOne, getStructure, saveStructure } from "../../services/db";
import pj from "./../../../package.json";
import { DialogPessoa } from "./DialogPessoa";
import { DialogVersion } from "./DialogVersion";
import { DialogSincronizaPessoa } from "./DialogSincronizaPessoa";
import Form from "./Form";
import FormSkeleton from "./FormSkeleton";
import Section from "./Section";
import SideDrawer from "./SideDrawer";
import SyncFeedback from "./SyncFeedback";
import TabNavigation from "./TabNavigation";
import WarningDialog from "./WarningDialog";
import { ConfirmDialog } from "./ConfirmDialog";
import { LeftBottomContainer } from "./styles";
import "./styles.css";
import { checkAutenticationByUrl } from "../../utils/checkAuthByUrl";
import { ContentCut, JoinFull } from "@mui/icons-material";
import { getSocket, socket } from "../../services/socket";
import { withSubPath } from "../../utils/withSubPath";
import {
  isVinculoEdificacaoAtivo,
  isVinculoEdificacaoDesativado,
  ordenarVinculosEdificacaoPorStatus,
} from "../../utils/edificacoesHierarchy";
import { edificacaoJaVinculadaAoImobiliario } from "../../utils/vincularEdificacaoRioBranco";

import { CircularProgress } from "@mui/material";

import { DialogSplitImobiliario } from "./DialogSplitImobiliario";
import { DialogJoin } from "./DialogJoin";
import { DialogVincularMultiImobiliario } from "./DialogVinculoMultiImobiliario";
import { DialogVincularEdificacaoRioBranco } from "./DialogVincularEdificacaoRioBranco";
import { webhookAtualizaDados } from "../../services/api";
import WebhookStatusPanel from "./Municipio/Maracanau/WebhookStatusPanel";
import { handleSincronizarDados, selecionarNovoImovel } from "../../services/utils";
import {
  atualizaPessoaPorImobiliario,
  exigeProprietarioNoImobiliario,
  ocultaBotoesVinculoManualPessoa,
  usaAvisoDebitosTitularidade,
  usaDialogSincronizaPessoa,
  usaIntegracaoPessoa,
  usaIntegracaoSync,
  usaJoinImobiliario,
  usaSplitImobiliario,
} from "../../constants/municipios";
import { hasIntegracaoSinter } from "../../utils/integracaoSinter";
import { imobiliarioPossuiDebitosAbertos } from "../../utils/imobiliarioDebitos";
import {
  buildSinterDesativacaoErrors,
  isStatusInativo,
  SINTER_MOTIVO_DESATIVACAO_COLUNA,
  SINTER_STATUS_COLUNA,
  SINTER_TABELA_IMOBILIARIO,
  SINTER_TIPO_DESATIVACAO_COLUNA,
} from "../../utils/sinterInativacao";
//

export default function Dashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const color = useContext(ColorModeContext);

  const {
    metadata,
    setMetadata,
    errors,
    setErrors,
    setShowDisabledImobiliario,
    showDisabledImobiliario,
    setShowDisabledEdificacoes,
    showDisabledEdificacoes,
    setShowEdificacoesSemVinculos,
    showEdificacoesSemVinculos,
    setShowIncorporatedImobiliario,
    showIncorporatedImobiliario,
    setFilterPessoaByImobiliario,
    filterPessoaByImobiliario,
    reloadFields,
    setReloadFields,
    setTotalPages,
    isLeitor
  } = useContext(DashboardContext);

  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [openDialogPessoa, setOpenDialogPessoa] = useState(false);

  const [openDialogSplitImobiliario, setOpenDialogSplitImobiliario] = useState(false);
  const [openDialogJoin, setOpenDialogJoin] = useState(false);
  const [openDialogVincularMultiImobiliario, setOpenDialogVincularMultiImobiliario] = useState(false);
  const [openDialogVincularEdificacaoRioBranco, setOpenDialogVincularEdificacaoRioBranco] = useState(false);
  const [openDialogSincronizaPessoa, setOpenDialogSincronizaPessoa] = useState(false);
  const municipio = localStorage.getItem("municipio")?.toLowerCase();
  const isRioBranco = municipio === "riobranco";
  const isPortoPecem = municipio === "portopecem";
  const loteSectionTitle = isPortoPecem ? "Área" : "Lote";
  const imobiliarioSectionTitle = isPortoPecem ? "Formulários" : "Imobiliário";
  const mensagensSectionTitle = isPortoPecem ? "Planos de ação - RNC" : "Mensagens";
  const visitasSectionTitle = isPortoPecem ? "Controle" : "Visitas & Controle";
  /* states para o feedback da sincronização */
  const [showModal, setShowModal] = useState(false);
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [confirmTitularidade, setConfirmTitularidade] = useState<{
    open: boolean;
    onConfirm: () => void;
  }>({ open: false, onConfirm: () => {} });
  const [confirmInativacaoSinter, setConfirmInativacaoSinter] = useState<{
    open: boolean;
    message: string;
    onConfirm: () => void;
  }>({ open: false, message: "", onConfirm: () => {} });
  const [errorLog, setErrorLog] = useState([]);
  const [configCaracterizacao, setConfigCaracterizacao] = useState<ConfigCaracterizacao>();
  const [integracaoSinter, setIntegracaoSinter] = useState(false);
  const [socketInstance, setSocketInstance] = useState(socket);
  const [warningMessage, setWarningMessage] = useState<string>("");
  const [isDataUpdated, setIsDataUpdated] = useState(false);
  const [initialMetadata, setInitialMetadata] = useState(metadata);
  const [minimized, setMinimized] = useState(false);
  const [shouldPassInitialMetadata, setShouldPassInitialMetadata] = useState(false);
  const [imobiliarioStatus, setImobiliarioStatus] = useState({
    joinImobiliario: false,
    splitImobiliario: false,
  });
  const [, startTransition] = useTransition();

  const tables: Tabelas[] = [
    "lote",
    "imobiliario",
    "imobiliario_edificacao",
    "edificacao",
    "pessoa",
    "imobiliario_pessoa",
    "visitas",
    "mensagens",
    "midia",
  ];

  async function checkHasAuthentication() {
    const tokens = getTokens();
    const responseCheck = await checkAutenticationByUrl();
    if (responseCheck) {
      return true;
    }

    if (!tokens['x-auth-token'] || !tokens['x-tn-token']) {
      return false;
    }

    localStorage.removeItem("callback");
    return true;
  }

  const releasesFetched = useRef(false);
  useEffect(() => {
    if (releasesFetched.current) return;
    releasesFetched.current = true;
  }, []);

  const initGuard = useRef({ inFlight: false, lastPath: "" });

  useEffect(() => {
    if (initGuard.current.lastPath === location.pathname) return;
    initGuard.current.lastPath = location.pathname;

    const run = async () => {
      if (initGuard.current.inFlight) return;
      initGuard.current.inFlight = true;

      const ok = await checkHasAuthentication();
      if (!ok) {
        const cb = window.location.pathname + window.location.search;
        if (window.location.pathname.includes("dashboard")) {
          localStorage.setItem("callback", cb);
          navigate("/?callback=" + cb, { replace: true });
        }
        initGuard.current.inFlight = false;
        return;
      }

      await asyncFunctionInit();
      initGuard.current.inFlight = false;
    };

    run();
  }, [location.pathname, navigate]);

  async function asyncFunctionInit() {
    setLoading(true);
    try {
      const projectInfo = await getTenantConfig();
      const sinterEnabled = hasIntegracaoSinter(projectInfo);
      setConfigCaracterizacao(projectInfo?.configCaracterizacao);
      setIntegracaoSinter(sinterEnabled);
      setSocketInstance(getSocket({ enableSinter: sinterEnabled }));

      const res = await fetchData();
      if (res?.navigated) return;

      await Promise.all([
        fetchPermissions(),
        fetchForms()
      ]);
      getFirstIds();
    } catch (e) {
      console.error("Erro durante a inicialização:", e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setSocketInstance(getSocket());
  }, []);

  async function fetchPermissions() {
    const permissions = await getPermissoesProjetos();
    if (metadata.permissoes || !permissions) return;

    setMetadata((current) => ({ ...current, permissoes: permissions }));
  }

  async function fetchForms() {
    const forms = await getForms();
    setMetadata((current) => ({ ...current, formularios: forms }));
  }

  function getFirstIds(table?: Tabelas) {
    if (table) {
      const data = getAll(table);
      if (data && data.length > 0) {
        const currentSelectedId = metadata[`id_${table}`];
        if (currentSelectedId) {
          const selectedExists = data.some((item: any) => String(item.id) === String(currentSelectedId));
          if (selectedExists) {
            return;
          }
        }

        if (table === "imobiliario") {
          const activeImobiliario = data.find((item: any) => item.status === 1 || item.status === "1");
          if (activeImobiliario) {
            setCurrentId(String(activeImobiliario.id), table);
          } else {
            setCurrentId(String(data[0].id), table);
          }
        } else {
          setCurrentId(String(data[0].id), table);
        }
      }
      return;
    }

    tables.forEach((table) => {
      const data = getAll(table);
      if (data && data.length > 0) {
        const currentSelectedId = metadata[`id_${table}`];
        if (currentSelectedId) {
          const selectedExists = data.some((item: any) => String(item.id) === String(currentSelectedId));
          if (selectedExists) {
            return;
          }
        }

        if (table === "imobiliario") {
          const activeImobiliario = data.find((item: any) => item.status === 1 || item.status === "1");
          if (activeImobiliario) {
            setCurrentId(String(activeImobiliario.id), table);
          } else {
            setCurrentId(String(data[0].id), table);
          }
        } else {
          setCurrentId(String(data[0].id), table);
        }
      }
    });
  }

  async function fetchData() {
    let id_lote: number;

    const param = location.pathname.split("/")[2];
    if (param && !isNaN(Number(param))) {
      id_lote = Number(param);
    } else {
      id_lote = await getFirstIdLote();
      navigate(`/dashboard/${id_lote}`, { replace: true });
      return { navigated: true };
    }

    if (isIdLoaded(String(id_lote))) {
      console.log("id já carregado");
      setCurrentId(String(id_lote), "lote");
      return;
    } else {
      clearData();
    }

    const data = await getData(id_lote);

    if (!data) {
      throw new Error("Não foi possível carregar os dados");
    }

    let maxPages = 1;

    const structuresMap = await getDataStructures(tables);

    for (let table of tables) {
      const structure = structuresMap[table];

      if (structure) {
        saveStructure(table, structure);
      }

      if (Array.isArray(data[table])) {
        data[table].forEach((item) => saveData(item, table));
      }

      if (data.pagination?.total_pages?.[table]) {
        maxPages = Math.max(maxPages, data.pagination.total_pages[table]);
      }
    }

    setTotalPages(maxPages);
    getFirstIds();
    setLoadedId(String(id_lote));
    setLoading(false);
  }

  function setCurrentId(id: string, tb: Tabelas) {
    if (tb === "imobiliario") {
      const owner = getOwnerFromImobiliario(id);
      const ed = getEdificacaoFromImobiliario(id);

      setMetadata((c) => {
        let idEdificacao = undefined;
        let idImobiliarioEdificacao = undefined;

        if (ed) {
          const edificacaoExists = getOne(String(ed.id_edificacao), "edificacao");
          if (edificacaoExists) {
            idEdificacao = String(ed.id_edificacao);
            idImobiliarioEdificacao = String(ed.id);
          } else {
            const currentEdificacao = c.id_edificacao;
            if (currentEdificacao) {
              const currentEdificacaoExists = getOne(String(currentEdificacao), "edificacao");
              if (currentEdificacaoExists) {
                idEdificacao = String(currentEdificacao);
              }
            }
          }
        } else {
          const currentEdificacao = c.id_edificacao;
          if (currentEdificacao) {
            const currentEdificacaoExists = getOne(String(currentEdificacao), "edificacao");
            if (currentEdificacaoExists) {
              idEdificacao = String(currentEdificacao);
            }
          }
        }

        return {
          ...c,
          id_imobiliario: String(id),
          id_imobiliario_pessoa: owner ? String(owner.id) : undefined,
          id_pessoa: owner ? String(owner.id_pessoa) : undefined,
          id_imobiliario_edificacao: idImobiliarioEdificacao,
          id_edificacao: idEdificacao,
        };
      });
      return;
    }

    if (tb === "pessoa") {
      setMetadata((c) => ({
        ...c,
        id_pessoa: c.id_pessoa ?? String(id),
      }));
      return;
    }

    setMetadata((c) => ({
      ...c,
      [`id_${tb}`]: String(id),
    }));
  }

  async function fetchAndUpdateDashboardData(id?: string, parameter?: string, shouldClearStorage: boolean = false) {
    const id_lote = metadata.id_lote;

    try {
      const data = await getData(Number(id_lote));

      if (!data) {
        throw new Error("Não foi possível carregar os dados atualizados do servidor.");
      }

      if (shouldClearStorage) {
        Object.keys(localStorage).forEach((key) => {
          const isListKey = /^list@\w+$/.test(key);
          const isIdKey = /^[0-9a-fA-F\-]{36}@\w+$/.test(key);
          if (isListKey || isIdKey) {
            localStorage.removeItem(key);
          }
        });

        localStorage.setItem('errors', JSON.stringify({}));

        setIsDataUpdated(true);
        setInitialMetadata(metadata);
        setShouldPassInitialMetadata(true);
      }

      const keysToRemove: string[] = [];
      Object.keys(localStorage).forEach((key) => {
        if (key.match(/^[0-9a-fA-F\-]{36}@[\w]+$/)) {
          keysToRemove.push(key);
        }
      });

      keysToRemove.forEach((key) => localStorage.removeItem(key));

      if (parameter === 'JoinImobiliario' && id) {
        const keysToRemoveFromStorage: string[] = [];
        Object.keys(localStorage).forEach((key) => {
          if (key.includes(`@imobiliario`) && key.includes(id)) {
            keysToRemoveFromStorage.push(key);
          }
        });
        keysToRemoveFromStorage.forEach((key) => localStorage.removeItem(key));

        const imobiliarios = getAll("imobiliario") || [];
        const updatedImobiliarios = imobiliarios.filter(
          (imovel: any) => imovel.id !== Number(id)
        );
        localStorage.setItem("list@imobiliario", JSON.stringify(updatedImobiliarios));

        Object.keys(metadata).forEach((key) => {
          if (metadata[key] === id) {
            metadata[key] = undefined;
          }
        });
      }

      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("list@")) {
          const rawValue = localStorage.getItem(key);
          if (rawValue) {
            try {
              const list = JSON.parse(rawValue);
              if (Array.isArray(list)) {
                const updatedList = list.filter((item) => {
                  if (typeof item.id === "string" && item.id.match(/^[0-9a-fA-F\-]{36}$/)) {
                    return false;
                  }
                  return true;
                });

                localStorage.setItem(key, JSON.stringify(updatedList));
              }
            } catch (error) {
              console.error(`Erro ao processar a lista no localStorage (${key}):`, error);
            }
          }
        }
      });

      const tablesToClean: Tabelas[] = [
        "edificacao",
        "imobiliario",
        "imobiliario_edificacao",
        "imobiliario_pessoa",
        "visitas",
        "mensagens",
        "midia",
      ];

      const returnedIdsByTable: Record<string, Set<string>> = {};

      Object.keys(data).forEach((table: string) => {
        if (Array.isArray(data[table])) {
          data[table] = data[table].filter((item: any) => {
            if (typeof item.id === "string" && item.id.match(/^[0-9a-fA-F\-]{36}$/)) {
              return false;
            }
            return true;
          });

          if (tablesToClean.includes(table as Tabelas)) {
            returnedIdsByTable[table] = new Set(
              data[table].map((item: any) => String(item.id))
            );
          }

          data[table].forEach((item: any) => {
            saveData(item, table as Tabelas);
          });
        }
      });

      tablesToClean.forEach((table) => {
        const returnedIds = returnedIdsByTable[table] || new Set<string>();
        const currentItems = getAll(table) || [];

        currentItems.forEach((item: any) => {
          const itemId = String(item.id);
          if (!returnedIds.has(itemId)) {
            del(itemId, table);
          }
        });
      });

      const metadataUpdates: Partial<typeof metadata> = {};

      Object.keys(metadata).forEach((key) => {
        if (typeof metadata[key] === "string" && metadata[key]?.match(/^[0-9a-fA-F\-]{36}$/)) {
          (metadataUpdates as any)[key] = undefined;
        }
      });

      tablesToClean.forEach((table) => {
        const metadataKey = `id_${table}`;
        const currentSelectedId = (metadata as any)[metadataKey];

        if (currentSelectedId) {
          const returnedIds = returnedIdsByTable[table] || new Set<string>();
          const itemExists = returnedIds.has(String(currentSelectedId));

          if (!itemExists) {
            (metadataUpdates as any)[metadataKey] = undefined;

            if (table === "imobiliario_edificacao") {
              const imobEdificacao = getOne(String(currentSelectedId), "imobiliario_edificacao");
              if (imobEdificacao) {
                const edificacaoId = String(imobEdificacao.id_edificacao);
                const edificacaoExists = returnedIdsByTable["edificacao"]?.has(edificacaoId);
                if (!edificacaoExists && metadata.id_edificacao === edificacaoId) {
                  (metadataUpdates as any).id_edificacao = undefined;
                }
              }
            }
          }
        }
      });

      const updatedMetadata = {
        ...metadata,
        ...metadataUpdates,
      };

      if (Object.keys(metadataUpdates).length > 0) {
        setMetadata(() => updatedMetadata);
      }

      const respLogs = await sendLogs();
      clearLogs();

      if (respLogs?.novosImoveis) {
        selecionarNovoImovel(respLogs.novosImoveis, setMetadata, getAll);
      }

      await fetchData();
      startTransition(() => setReloadFields((prev) => !prev));
      setIsDataUpdated(true);
      setInitialMetadata(updatedMetadata);
      setShouldPassInitialMetadata(true);
      if (parameter === 'JoinImobiliario' && id) {
        setImobiliarioStatus((prev) => ({
          ...prev,
          joinImobiliario: true,
        }));
        setShouldPassInitialMetadata(false);
      }
      if (parameter === "SplitImobiliario"){
        setImobiliarioStatus((prev) => ({
          ...prev,
          splitImobiliario: true,
        }));
        setShouldPassInitialMetadata(false);
      }
    } catch (error) {
      console.error("Erro ao atualizar dados do dashboard:", error);
      toast.error("Erro ao atualizar os dados do dashboard.");
    }
  }

  function isVinculoProprietario(link: ImobiliarioPessoa & { tipo_proprietario?: number | string }): boolean {
    const tipoBase = link.tipo ?? link.tipo_proprietario;
    return tipoBase === 1 || String(tipoBase) === "1";
  }

  function getOwnerFromImobiliario(imobId: string): ImobiliarioPessoa | undefined {
    const links = (getAll("imobiliario_pessoa") || []) as (ImobiliarioPessoa & {
      tipo_proprietario?: number | string;
    })[];

    return links.find((l) => String(l.id_imobiliario) === String(imobId) && isVinculoProprietario(l));
  }

  function getFirstPessoaFromImobiliario(imobId?: string): ImobiliarioPessoa | undefined {
    if (!imobId) {
      return undefined;
    }

    const links = (getAll("imobiliario_pessoa") || []) as ImobiliarioPessoa[];
    return links.find((link) => String(link.id_imobiliario) === String(imobId));
  }

  function getEdificacaoFromImobiliario(imobId: string): ImobiliarioEdificacao | undefined {
    const links = (getAll("imobiliario_edificacao") || []) as ImobiliarioEdificacao[];
    return ordenarVinculosEdificacaoPorStatus(
      links.filter((l) => String(l.id_imobiliario) === String(imobId))
    ).find(isVinculoEdificacaoAtivo);
  }

  function handleChangeImobiliario(_e: React.SyntheticEvent, newValue: string) {
    const owner = getOwnerFromImobiliario(newValue);
    const ed = getEdificacaoFromImobiliario(newValue);

    setMetadata((cur) => {
      let idEdificacao = undefined;
      let idImobiliarioEdificacao = undefined;

      if (ed) {
        const edificacaoExists = getOne(String(ed.id_edificacao), "edificacao");
        if (edificacaoExists) {
          idEdificacao = String(ed.id_edificacao);
          idImobiliarioEdificacao = String(ed.id);
        } else {
          const currentEdificacao = cur.id_edificacao;
          if (currentEdificacao) {
            const currentEdificacaoExists = getOne(String(currentEdificacao), "edificacao");
            if (currentEdificacaoExists) {
              idEdificacao = String(currentEdificacao);
            }
          }
        }
      } else {
        const currentEdificacao = cur.id_edificacao;
        if (currentEdificacao) {
          const currentEdificacaoExists = getOne(String(currentEdificacao), "edificacao");
          if (currentEdificacaoExists) {
            idEdificacao = String(currentEdificacao);
          }
        }
      }

      return {
        ...cur,
        id_imobiliario: newValue,
        id_imobiliario_pessoa: owner ? String(owner.id) : undefined,
        id_pessoa: owner ? String(owner.id_pessoa) : undefined,
        id_imobiliario_edificacao: idImobiliarioEdificacao,
        id_edificacao: idEdificacao,
      };
    });
  }

  function handleChangePessoa(event: React.SyntheticEvent, newValue: string) {
    const listImobiliarioPessoa = (getAll("imobiliario_pessoa") || []) as ImobiliarioPessoa[];

    const theImobiliarioPessoa = listImobiliarioPessoa.find(
      (item) => String(item.id_pessoa) === newValue && String(item.id_imobiliario) === metadata.id_imobiliario,
    );

    setMetadata((current) => ({
      ...current,
      id_imobiliario_pessoa:
        theImobiliarioPessoa && theImobiliarioPessoa.id ? String(theImobiliarioPessoa.id) : undefined,
      id_pessoa: newValue,
    }));
  }

  function handleChangeEdificacao(
    event: React.SyntheticEvent,
    newValue: string,
    idImobiliarioEdificacao?: string,
  ) {
    const listImobiliarioEdificacao = (getAll("imobiliario_edificacao") || []) as ImobiliarioEdificacao[];
    const vinculosDaEdificacao = ordenarVinculosEdificacaoPorStatus(
      listImobiliarioEdificacao.filter(
        (item) =>
          String(item.id_edificacao) === newValue &&
          String(item.id_imobiliario) === metadata.id_imobiliario,
      ),
    );

    let theImobiliarioEdificacao: ImobiliarioEdificacao | undefined;

    if (idImobiliarioEdificacao) {
      theImobiliarioEdificacao = vinculosDaEdificacao.find(
        (item) => String(item.id) === String(idImobiliarioEdificacao),
      );
    } else {
      theImobiliarioEdificacao = vinculosDaEdificacao.find(isVinculoEdificacaoAtivo);
    }

    setMetadata((current) => ({
      ...current,
      [`id_imobiliario_edificacao`]: theImobiliarioEdificacao?.id ? String(theImobiliarioEdificacao?.id) : undefined,
      [`id_edificacao`]: newValue,
    }));
  }

  function handleChangeVisitas(event: React.SyntheticEvent, newValue: string) {
    setMetadata((current) => ({
      ...current,
      [`id_visitas`]: newValue,
    }));
  }

  async function handleAddVisita() {
    let visita = await createVisita(metadata.id_imobiliario!);

    setCurrentId(visita.id, "visitas");
  }

  async function handleRemoveVisita() {
    removeVisita(metadata.id_visitas!);
    setMetadata((current) => ({
      ...current,
      id_visitas: undefined,
    }));
  }

  function handleChangeMensagens(event: React.SyntheticEvent, newValue: string) {
    setMetadata((current) => ({
      ...current,
      [`id_mensagens`]: newValue,
    }));
  }

  async function handleAddMensagem() {
    let mensagem = await createMensagem(metadata.id_imobiliario!, metadata.id_lote!);

    setCurrentId(mensagem.id, "mensagens");
  }

  async function handleRemoveMensagem() {
    removeMensagem(metadata.id_mensagens!);
    setMetadata((current) => ({
      ...current,
      id_mensagens: undefined,
    }));
  }

  async function handleAddImobiliario() {
    let imobiliario = await createImobiliario(metadata.id_lote!);

    setCurrentId(imobiliario.id, "imobiliario");
  }

  function handleRemoveImobiliario() {
    const listImobiliario = getAll("imobiliario");

    if (!checkIfTipoImpostoIsDisabled()) {
      handleTipoImposto();
    } else if (
      listImobiliario &&
      listImobiliario.filter((imobiliario: any) => imobiliario.status === 1 || imobiliario.status === "1").length > 1
    ) {
      const statusDelete = deleteImobiliario(metadata.id_imobiliario!);

      if (statusDelete) {
        toast.success("Sucesso ao deletar imobiliário ");

        setMetadata((current) => ({
          ...current,
          [`id_imobiliario`]: undefined,
        }));
      } else {
        toast.error("Falha ao deletar imobiliário ");
      }
    }
  }

  function handleAddPessoa() {
    setOpenDialogPessoa(true);
  }

  const MENSAGEM_DEBITOS_TITULARIDADE =
    "Este imóvel possui débitos vinculados que passarão a ser de responsabilidade do novo titular. Deseja continuar com a troca de titularidade?";

  function executarComAvisoDebitos(acao: () => void) {
    if (!usaAvisoDebitosTitularidade(municipio) || !metadata.id_imobiliario) {
      acao();
      return;
    }

    imobiliarioPossuiDebitosAbertos(municipio, metadata.id_imobiliario).then((possuiDebitos) => {
      if (!possuiDebitos) {
        acao();
        return;
      }

      setConfirmTitularidade({
        open: true,
        onConfirm: () => {
          setConfirmTitularidade({ open: false, onConfirm: () => {} });
          acao();
        },
      });
    });
  }

  function handleDesvincularPessoa() {
    const vinculos = (getAll("imobiliario_pessoa") || []) as ImobiliarioPessoa[];
    const vinculo = vinculos.find(
      (link) => String(link.id) === String(metadata.id_imobiliario_pessoa)
    );
    const isTitular = !!vinculo && isVinculoProprietario(vinculo);

    const desvincular = () => {
      removePessoaFromImobiliario(metadata.id_imobiliario_pessoa!);
      setMetadata((current) => ({
        ...current,
        id_imobiliario_pessoa: undefined,
      }));
    };

    if (isTitular) {
      executarComAvisoDebitos(desvincular);
      return;
    }

    desvincular();
  }

  function handleDesvincularEdificacao() {
    removeEdificacaoFromImobiliario(metadata.id_imobiliario_edificacao!);
    setMetadata((current) => ({
      ...current,
      id_imobiliario_edificacao: undefined,
    }));
  }

  function getVinculoImobiliarioEdificacaoSelecionado(): ImobiliarioEdificacao | undefined {
    if (!metadata.id_imobiliario_edificacao) return undefined;

    const vinculos = (getAll("imobiliario_edificacao") || []) as ImobiliarioEdificacao[];
    return vinculos.find((vinculo) => String(vinculo.id) === String(metadata.id_imobiliario_edificacao));
  }

  function isVincularEdificacaoDisabled() {
    if (!metadata.id_edificacao || !metadata.id_imobiliario) return true;

    if (municipio === "riobranco") {
      const vinculoSelecionado = getVinculoImobiliarioEdificacaoSelecionado();

      if (!vinculoSelecionado) {
        const vinculos = (getAll("imobiliario_edificacao") || []) as ImobiliarioEdificacao[];
        return edificacaoJaVinculadaAoImobiliario(
          vinculos,
          metadata.id_imobiliario,
          metadata.id_edificacao,
        );
      }

      return isVinculoEdificacaoAtivo(vinculoSelecionado);
    }

    return metadata.id_imobiliario_edificacao !== undefined;
  }

  function isDesvincularEdificacaoDisabled() {
    if (!metadata.id_imobiliario_edificacao) return true;

    if (municipio === "riobranco") {
      const vinculo = getVinculoImobiliarioEdificacaoSelecionado();
      if (!vinculo?.id || Number(vinculo.id) === 0) return true;

      return isVinculoEdificacaoDesativado(vinculo) || !isVinculoEdificacaoAtivo(vinculo);
    }

    return false;
  }

  function handleVincularEdificacao() {
    if (municipio === "riobranco") {
      setOpenDialogVincularEdificacaoRioBranco(true);
      return;
    }

    const imobiliarioEdificacao = addEdificacaoToImobiliario(metadata.id_edificacao!, metadata.id_imobiliario!);

    setMetadata((current) => ({
      ...current,
      id_imobiliario_edificacao: imobiliarioEdificacao.id!,
    }));
  }

  function handleVinculoEdificacaoRioBrancoConcluido(resultado: {
    id_imobiliario: string;
    id_imobiliario_edificacao: string;
    id_edificacao: string;
    novoImobiliario?: boolean;
  }) {
    setMetadata((current) => ({
      ...current,
      id_imobiliario: resultado.id_imobiliario,
      id_edificacao: resultado.id_edificacao,
      id_imobiliario_edificacao: resultado.id_imobiliario_edificacao,
    }));

    if (resultado.novoImobiliario) {
      setImobiliarioStatus((prev) => ({ ...prev, splitImobiliario: true }));
    }
  }

  function handleVincularPessoa() {
    const vincular = () => {
      const pessoa = getOne(metadata.id_pessoa!, "pessoa");
      const imobiliarioPessoa = addPessoaToImobiliario(pessoa!, metadata.id_imobiliario!);

      setMetadata((current) => ({
        ...current,
        id_imobiliario_pessoa: String(imobiliarioPessoa.id),
      }));
    };

    executarComAvisoDebitos(vincular);
  }

  function handleSplitImobiliario(){
    setOpenDialogSplitImobiliario(true);
  }

  function handleJoinImobiliario(){
    setOpenDialogJoin(true);
  }

  function handleValidaVinculoPessoaMaracanau(): boolean {
    const allImobiliarios = getAll("imobiliario") || [];
    const listImobiliarioPessoa = getAll("imobiliario_pessoa") || [];

    const newImobiliarios = allImobiliarios.filter((imobiliario: any) => {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return uuidRegex.test(imobiliario.id);
    });

    const newWithoutVinculoPessoa = newImobiliarios.filter((imobiliario: any) => {
      return !listImobiliarioPessoa.some(
        (link: any) => String(link.id_imobiliario) === String(imobiliario.id) && isVinculoProprietario(link)
      );
    });

    if (newWithoutVinculoPessoa.length > 0) {
      setWarningMessage(
        "Um ou mais imóveis que estão sendo criados não possuem proprietário vinculado. Certifique-se de vincular pelo menos um proprietário a cada novo imóvel antes de salvar."
      );
      setOpenWarningDialog(true);
      return false;
    }
    return true;
  }

  function getParsedLocalLog() {
    const logFromStorage = localStorage.getItem("log");
    if (!logFromStorage) return null;

    try {
      return JSON.parse(logFromStorage);
    } catch {
      return null;
    }
  }

  function validateSinterInativacaoBeforeSave(): boolean {
    if (!integracaoSinter || !metadata.id_imobiliario) return true;

    const imobiliario = getOne(metadata.id_imobiliario, SINTER_TABELA_IMOBILIARIO);
    const sinterErrors = buildSinterDesativacaoErrors({
      id: metadata.id_imobiliario,
      status: imobiliario?.[SINTER_STATUS_COLUNA],
      tipo: imobiliario?.[SINTER_TIPO_DESATIVACAO_COLUNA],
      motivo: imobiliario?.[SINTER_MOTIVO_DESATIVACAO_COLUNA],
    });

    const storageErrors = JSON.parse(localStorage.errors || "{}");
    const nextErrors = { ...storageErrors };
    [
      `${metadata.id_imobiliario}@${SINTER_TABELA_IMOBILIARIO}@${SINTER_TIPO_DESATIVACAO_COLUNA}`,
      `${metadata.id_imobiliario}@${SINTER_TABELA_IMOBILIARIO}@${SINTER_MOTIVO_DESATIVACAO_COLUNA}`,
    ].forEach((key) => delete nextErrors[key]);

    const mergedErrors = { ...nextErrors, ...sinterErrors };
    localStorage.setItem("errors", JSON.stringify(mergedErrors));
    setErrors(mergedErrors);

    if (Object.keys(sinterErrors).length > 0) {
      toast.error("Preencha os campos obrigatórios da inativação SINTER antes de salvar.");
      return false;
    }

    return true;
  }

  function getSinterInativacaoPendenteIds(): string[] {
    if (!integracaoSinter) return [];

    const log = getParsedLocalLog();
    const ids = new Set<string>();

    log?.updates
      ?.filter(
        (update: any) =>
          update.nome_tabela === SINTER_TABELA_IMOBILIARIO &&
          update.nome_campo === SINTER_STATUS_COLUNA &&
          isStatusInativo(update.valor_campo),
      )
      .forEach((update: any) => ids.add(String(update.id_origem)));

    if (metadata.id_imobiliario) {
      const statusUpdate = log?.updates?.find(
        (update: any) =>
          update.nome_tabela === SINTER_TABELA_IMOBILIARIO &&
          update.nome_campo === SINTER_STATUS_COLUNA &&
          String(update.id_origem) === String(metadata.id_imobiliario),
      );
      const imobiliario = getOne(metadata.id_imobiliario, SINTER_TABELA_IMOBILIARIO);

      if (statusUpdate && isStatusInativo(imobiliario?.[SINTER_STATUS_COLUNA])) {
        ids.add(String(metadata.id_imobiliario));
      }
    }

    return Array.from(ids);
  }

  function buildMensagemConfirmacaoInativacaoSinter(quantidade: number): string {
    if (quantidade > 1) {
      return `Você está inativando ${quantidade} imobiliários. Essa ação também irá inativar os cadastros no SINTER. Deseja continuar?`;
    }

    return "Você está inativando este imobiliário. Essa ação também irá inativar o cadastro no SINTER. Deseja continuar?";
  }

  async function executeSave() {
    setIsSaving(true);

    const logFromStorage = localStorage.getItem("log");
    const hasLogs = logFromStorage !== null;
    const hasInserts = (() => {
      if (!logFromStorage) return false;
      try {
        const parsed = JSON.parse(logFromStorage);
        return Array.isArray(parsed?.inserts) && parsed.inserts.length > 0;
      } catch {
        return false;
      }
    })();

    const toastId = toast.loading(
      hasLogs
        ? "Salvando as alterações. Por favor, aguarde enquanto os dados são processados e atualizados."
        : "Não há dados para salvar, mas os dados serão atualizados."
    );

    try {
        const respLogs = await sendLogs();
        clearLogs();

        if (respLogs?.novosImoveis) {
          selecionarNovoImovel(respLogs.novosImoveis, setMetadata, getAll);
        }

        const shouldClearAfterSave =
          hasInserts ||
          (respLogs?.inserts_ids && respLogs.inserts_ids.length > 0) ||
          (respLogs?.novosImoveis && respLogs.novosImoveis.length > 0);

        await fetchAndUpdateDashboardData(undefined, undefined, shouldClearAfterSave);

        toast.dismiss(toastId);
        toast.success(hasLogs
          ? "Dados salvos e atualizados com sucesso."
          : "Dados atualizados com sucesso.");
        setIsSaving(false);
    } catch (error: any) {
        console.error("Erro ao salvar os dados", error);

        if (error.response?.status === 422) {
            toast.dismiss(toastId);
            toast.error("Houve um erro com o formato dos dados, envie um chamado para o helpdesk");
        } else if (error.response?.status === 500) {
            toast.dismiss(toastId);
            toast.error("Ocorreu um erro desconhecido, por favor, envie um chamado para o helpdesk");
        } else {
            toast.dismiss(toastId);
            toast.error("Houve um erro ao salvar os dados");
            setErrorLog(error.response?.data?.errors || []);
            setShowModal(true);
        }

        setIsSaving(false);
    }
  }

  async function handleSave() {
    if (exigeProprietarioNoImobiliario(configCaracterizacao, municipio)) {
        if (!handleValidaVinculoPessoaMaracanau()) {
            return;
        }

        const listImobiliarioPessoa = (getAll("imobiliario_pessoa") || []) as ImobiliarioPessoa[];
        const pessoasVinculadas = listImobiliarioPessoa.filter(
            (pessoa) =>
                String(pessoa.id_imobiliario) === metadata.id_imobiliario &&
                    isVinculoProprietario(pessoa)
        );

        if (pessoasVinculadas.length === 0) {
            setWarningMessage("É necessário ter ao menos um proprietário vinculado ao imobiliário antes de salvar.");
            setOpenWarningDialog(true);
            return;
        }
    }

    if (!validateSinterInativacaoBeforeSave()) {
      return;
    }

    const sinterInativacaoIds = getSinterInativacaoPendenteIds();

    if (sinterInativacaoIds.length > 0) {
      setConfirmInativacaoSinter({
        open: true,
        message: buildMensagemConfirmacaoInativacaoSinter(sinterInativacaoIds.length),
        onConfirm: () => {
          setConfirmInativacaoSinter({ open: false, message: "", onConfirm: () => {} });
          executeSave();
        },
      });
      return;
    }

    await executeSave();
  }
  function checkIfImobiliarioIsDisabled() {
    const strutuctureImobiliario = getStructure("imobiliario");
    const dataSelectedImobiliario = getOne(metadata.id_imobiliario!, "imobiliario");

    return !(
      strutuctureImobiliario !== null &&
      strutuctureImobiliario.hasOwnProperty("status") &&
      (dataSelectedImobiliario?.status === 1 || dataSelectedImobiliario?.status === "1")
    );
  }

  function checkIfTipoImpostoIsDisabled() {
    const strutuctureLote = getStructure("lote");
    const strutuctureImobiliario = getStructure("imobiliario");
    const dataSelectedLote = getOne(metadata.id_lote!, "lote");
    const listImobiliario = getAll("imobiliario");

    return !(
      strutuctureLote !== null &&
      strutuctureImobiliario !== null &&
      strutuctureImobiliario.hasOwnProperty("status") &&
      listImobiliario &&
      listImobiliario.filter((imobiliario: any) => imobiliario.status === 1 || imobiliario.status === "1").length ===
        1 &&
      strutuctureLote.hasOwnProperty("tipo_imposto") &&
      (dataSelectedLote?.tipo_imposto === 1 || dataSelectedLote?.tipo_imposto === "1")
    );
  }

  function handleTipoImposto() {
    if (!checkIfTipoImpostoIsDisabled()) {
      const statusChangeTipoImposto = patchTipoImpostoTo2(metadata.id_lote!);

      if (statusChangeTipoImposto) {
        toast.success("Tipo imposto alterado para Territorial");
        setReloadFields(!reloadFields);
        return true;
      } else {
        toast.error("Falha ao trocar campo Tipo Imposto");
        return false;
      }
    }
  }

  function openAuditoriaCadastro(camada: string, idCamada: string, idOpcional?: string) {
    const params = new URLSearchParams();
    params.set("camada", camada);

    if (camada == "lote") {
      params.set("propriedade", "id");
      params.set("valor_propriedade", idCamada);
    } else if (camada == "pessoa" || camada == "edificacao") {
      params.set(
        "and",
        `(or(camada.eq.${camada},camada.eq.imobiliario_${camada}),or(body_novo->>id.in.(${idCamada},${idOpcional}),body_antigo->>id.in.(${idCamada},${idOpcional})))`
      );
    } else {
      params.set("or", `(body_novo->>id.eq.${idCamada},body_antigo->>id.eq.${idCamada})`);
    }

    window.open(withSubPath(`/auditoria/cadastro?${params.toString()}`), "_blank");
  }

  function handleFilterPessoaByImobiliario() {
    setFilterPessoaByImobiliario((current) => {
      const newFilterState = !current;

      if (newFilterState) {
        const pessoasVinculadas = (getAll("imobiliario_pessoa") || []).filter(
          (pessoa) => String(pessoa.id_imobiliario) === metadata.id_imobiliario
        );

        setMetadata((prev) => ({
          ...prev,
          id_pessoa: pessoasVinculadas.length > 0 ? String(pessoasVinculadas[0].id_pessoa) : undefined,
        }));
      } else {
        setMetadata((prev) => ({
          ...prev,
          id_pessoa: undefined,
        }));
      }

      return newFilterState;
    });
  }

  async function handleAtualizarPessoaTributario() {
    const usaImobiliario = atualizaPessoaPorImobiliario(municipio);
    const identificador = usaImobiliario ? metadata.id_imobiliario : metadata.id_pessoa;

    if (!identificador) {
      toast.error(
        usaImobiliario
          ? "Selecione um imobiliário para atualizar as informações."
          : "Selecione uma pessoa para atualizar as informações."
      );
      return;
    }

    const toastId = toast.loading("Realizando atualização de informações da pessoa");

    try {
      const result = await webhookAtualizaDados("atualiza-pessoa", { id: identificador });

      if (!result) {
        toast.dismiss(toastId);
        toast.error("Falha ao atualizar as informações da pessoa.");
        return;
      }

      await fetchAndUpdateDashboardData(undefined, undefined, true);

      setMetadata((prev) => {
        if (!prev.id_imobiliario) {
          return prev;
        }

        const owner = getOwnerFromImobiliario(prev.id_imobiliario);
        const firstPessoaFromList = getFirstPessoaFromImobiliario(prev.id_imobiliario);
        const pessoaSelecionada = firstPessoaFromList ?? owner;

        const nextMetadata = {
          ...prev,
          id_imobiliario_pessoa: pessoaSelecionada?.id ? String(pessoaSelecionada.id) : undefined,
          id_pessoa: pessoaSelecionada?.id_pessoa ? String(pessoaSelecionada.id_pessoa) : undefined,
        };

        setInitialMetadata(nextMetadata);

        return nextMetadata;
      });

      toast.dismiss(toastId);
      toast.success("Informações da pessoa atualizadas com sucesso.");
    } catch (error) {
      toast.dismiss(toastId);
      console.error("Erro ao atualizar pessoa com dados tributários:", error);
      toast.error("Erro ao atualizar as informações da pessoa.");
    }
  }

  useEffect(() => {
    if (filterPessoaByImobiliario && metadata.id_imobiliario) {
      const pessoasVinculadas = (getAll("imobiliario_pessoa") || []).filter(
        (pessoa) => String(pessoa.id_imobiliario) === metadata.id_imobiliario
      );

      setMetadata((prev) => ({
        ...prev,
        id_pessoa: pessoasVinculadas.length > 0 ? String(pessoasVinculadas[0].id_pessoa) : undefined,
      }));
    }
  }, [filterPessoaByImobiliario, metadata.id_imobiliario]);

  const handleSincronizarDadosOrDialog = () => {
    if (usaDialogSincronizaPessoa(municipio)) {
      setOpenDialogSincronizaPessoa(true);
    } else {
      void handleSincronizarDados(metadata, "pessoa", fetchAndUpdateDashboardData, integracaoSinter);
    }
  }

  const exigirPreenchimentoObrigatorio = configCaracterizacao?.naoExigirPreenchimentoObrigatorio === false;
  const shouldSaveButtonBeDisabled = isSaving || (exigirPreenchimentoObrigatorio && Object.values(errors).some((err) => err.severity === "error"));

  return (
    <>
      <Box
        sx={{
          width: metadata.drawer ? "68vw" : "95vw",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          id="logo-container"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            width: "100%",
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(2),
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <img
                className="logo-dashboard"
                src={theme.palette.mode === "dark" ? logo : logoLight}
                alt="logo"
                onClick={() => console.log(metadata)}
              />
              <Divider
                sx={{
                  marginRight: theme.spacing(1),
                  marginLeft: theme.spacing(1),
                }}
                orientation="vertical"
                flexItem
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  variant="caption"
                  fontWeight={"700"}
                  fontStyle={{
                    color: alpha(theme.palette.text.secondary, 0.4),
                  }}
                >
                  Caracterização
                </Typography>

                <DialogVersion>
                  {pj.version} - {environments.ambiente}{" "}
                </DialogVersion>
              </Box>
            </Box>
            <Box id="dark-mode-toggle" sx={{ display: "flex", gap: theme.spacing(1) }}>
              <TabNavigation integracaoSinter={integracaoSinter} municipio={municipio} />
              <IconButton onClick={color.toggleColorMode} color="inherit">
                {theme.palette.mode === "dark" ? <Brightness7Icon /> : <DarkModeIcon />}
              </IconButton>
            </Box>
          </Box>
        </Box>

        <SideDrawer showCloseCaracterizacao={isRioBranco && metadata.drawer} />

        <Box>
          {configCaracterizacao && (!("desabilitaLote" in configCaracterizacao) || !configCaracterizacao.desabilitaLote) && (
            <Section
              id={loteSectionTitle}
              titulo={loteSectionTitle}
              options={[
                usaIntegracaoSync(municipio) && (
                  <Tooltip key={"sync-lote"} title="Sincronizar dados do lote" sx={{ marginTop: 2 }}>
                    <IconButton onClick={() => handleSincronizarDados(metadata, "lote", fetchAndUpdateDashboardData, integracaoSinter)}>
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                ),
                !metadata.permissoes ? (
                  <Box key="loading-audit-lote" sx={{ marginTop: 4, display: "flex", alignItems: "center" }}>
                    <CircularProgress size={20} />
                  </Box>
                ) : (
                  <Tooltip key="open-audit-lote" title="Abrir auditoria do lote" sx={{ marginTop: 2 }}>
                    <span>
                      <IconButton
                        sx={{ mt: 3 }}
                        disabled={!metadata.id_lote || isLeitor}
                        onClick={() => openAuditoriaCadastro("lote", metadata.id_lote!)}
                      >
                        <ContentPasteSearchIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                ),
              ]}
              initialMetadata={shouldPassInitialMetadata ? initialMetadata : undefined}
              shouldPassInitialMetadata={shouldPassInitialMetadata}
              setShouldPassInitialMetadata={setShouldPassInitialMetadata}
              imobiliarioStatus={imobiliarioStatus}
              setImobiliarioStatus={setImobiliarioStatus}
              isDataUpdated={isDataUpdated}
              setIsDataUpdated={setIsDataUpdated}
            >
              {!metadata.formularios || loading ? (
                <FormSkeleton />
              ) : !metadata.formularios.lote?.length ? (
                <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
              ) : (
                <Form formularios={metadata.formularios.lote} tabela={"lote"} />
              )}
            </Section>
          )}
          {configCaracterizacao &&
            (!("desabilitaImobiliario" in configCaracterizacao) ||
            !configCaracterizacao.desabilitaImobiliario) && (
              <Section
                id={imobiliarioSectionTitle}
                titulo={imobiliarioSectionTitle}
                tabela={"imobiliario"}
                handleChangeFn={handleChangeImobiliario}
                options={[
                  <Tooltip key={"add-imob"} title="Adicionar imobiliário">
                    <IconButton onClick={handleAddImobiliario} color="success">
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>,
                  <Tooltip key={"del-imob"} title="Remover imobiliário" color="error">
                    <IconButton onClick={handleRemoveImobiliario} disabled={checkIfImobiliarioIsDisabled()}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>,

                    ...(usaSplitImobiliario(municipio)
                      ? [
                        <Tooltip key="split-imob" title="Desmembrar imobiliário">
                          <IconButton onClick={handleSplitImobiliario} disabled={checkIfImobiliarioIsDisabled()}>
                            <ContentCut />
                          </IconButton>
                        </Tooltip>,
                      ]
                      : []),
                    ...(usaJoinImobiliario(municipio)
                      ? [
                        <Tooltip key="join-imob" title="Juntar imobiliários">
                          <IconButton onClick={handleJoinImobiliario} disabled={checkIfImobiliarioIsDisabled()}>
                            <JoinFull />
                          </IconButton>
                        </Tooltip>,
                        <Tooltip key={"sync-imobiliario"} title="Sincronizar dados do imobiliário">
                          <IconButton onClick={() => handleSincronizarDados(metadata, "imobiliario", fetchAndUpdateDashboardData, integracaoSinter)}>
                            <RefreshIcon />
                          </IconButton>
                        </Tooltip>
                      ]
                      : []),
                  <Tooltip key={"open-audit-imob"} title="Abrir auditoria do imobiliário">
                    <IconButton
                      disabled={!metadata.id_imobiliario}
                      onClick={() =>
                        metadata.id_imobiliario && openAuditoriaCadastro("imobiliario", metadata.id_imobiliario)
                      }
                    >
                      <ContentPasteSearchIcon />
                    </IconButton>
                  </Tooltip>,
                ]}
                extraOptions={[
                  <Tooltip key={"show-delete-imob"} title="Exibir imobiliários desabilitados">
                    <Box sx={{ display: "flex" }}>
                      <FormControlLabel
                        checked={showDisabledImobiliario}
                        onChange={(e: GenericObject) => {
                          setShowDisabledImobiliario(e.target.checked);
                        }}
                        control={<Checkbox color="default" />}
                        label="Exibir imobiliários desativados"
                      />
                    </Box>
                  </Tooltip>,

                  municipio === "maracanau" && (
                    <Tooltip key={"show-incorporated-imob"} title="Exibir imobiliários incorporados">
                      <Box sx={{ display: "flex" }}>
                        <FormControlLabel
                          checked={showIncorporatedImobiliario}
                          onChange={(e: GenericObject) => {
                            setShowIncorporatedImobiliario(e.target.checked);
                          }}
                          control={<Checkbox color="default" />}
                          label="Exibir imobiliários incorporados"
                        />
                      </Box>
                    </Tooltip>
                  ),
                ]}
                initialMetadata={shouldPassInitialMetadata ? initialMetadata : undefined}
                shouldPassInitialMetadata={shouldPassInitialMetadata}
                setShouldPassInitialMetadata={setShouldPassInitialMetadata}
                imobiliarioStatus={imobiliarioStatus}
                setImobiliarioStatus={setImobiliarioStatus}
                isDataUpdated={isDataUpdated}
                setIsDataUpdated={setIsDataUpdated}
              >
                {!metadata.formularios || loading ? (
                  <FormSkeleton />
                ) : !metadata.formularios.imobiliario?.length ? (
                  <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
                ) : (
                  <Form
                    formularios={metadata.formularios.imobiliario}
                    tabela={"imobiliario"}
                    configCaracterizacao={configCaracterizacao}
                    integracaoSinter={integracaoSinter}
                  />
                )}
              </Section>
            )}
          {configCaracterizacao &&
            (!("desabilitaPessoa" in configCaracterizacao) ||
            !configCaracterizacao.desabilitaPessoa) && (
              <Section
                id="Pessoa"
                titulo="Pessoa"
                tabela={"pessoa"}
                handleChangeFn={handleChangePessoa}
                options={[
                  <Tooltip key={"add-pessoa"} title="Adicionar uma nova pessoa ao imobiliário">
                    <IconButton
                      onClick={handleAddPessoa}
                      color="success"
                      disabled={metadata.id_imobiliario === undefined}
                    >
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>,
                    !ocultaBotoesVinculoManualPessoa(municipio) && (
                      <>
                        <Tooltip key={"add-imob-pessoa"} title="Vincular pessoa ao imobiliário">
                          <IconButton onClick={handleVincularPessoa} disabled={metadata.id_imobiliario_pessoa !== undefined}>
                            <LinkIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip key={"del-imob-pessoa"} title="Desvincular pessoa do imobiliário">
                          <IconButton
                            onClick={handleDesvincularPessoa}
                            disabled={metadata.id_imobiliario_pessoa === undefined}
                          >
                            <LinkOffIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    )
                  ,usaIntegracaoPessoa(municipio) && (
                      <>
                        <Tooltip key={"atualizar-pessoa"} title="Atualizar informações da pessoa">
                          <IconButton onClick={handleAtualizarPessoaTributario}>
                            <UpdateIcon />
                          </IconButton>
                        </Tooltip>

                        {municipio === 'maracanau' && (
                          <Tooltip key={"vincular-multi-pessoa"} title="Vincular o proprietário a vários imóveis">
                            <IconButton
                              onClick={() => {
                                setOpenDialogVincularMultiImobiliario(true);
                                setMinimized(false);
                              }}
                              disabled={metadata.id_imobiliario === undefined}
                            >
                              <LinkIcon fontSize="small" />
                              <HomeWorkIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}

                        <Tooltip key={"sync-pessoa"} title="Sincronizar dados da pessoa">
                          <IconButton onClick={() => handleSincronizarDadosOrDialog()}>
                            <RefreshIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    ),
                  <Tooltip key={"open-audit-pessoa"} title="Abrir auditoria da pessoa">
                    <IconButton
                      disabled={!metadata.id_pessoa}
                      onClick={() =>
                        metadata.id_pessoa &&
                        openAuditoriaCadastro("pessoa", metadata.id_pessoa, metadata.id_imobiliario_pessoa)
                      }
                    >
                      <ContentPasteSearchIcon />
                    </IconButton>
                  </Tooltip>
                  ]}
                extraOptions={[
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={filterPessoaByImobiliario}
                          onChange={handleFilterPessoaByImobiliario}
                        />
                      }
                      label={"Visualizar apenas pessoas do imobiliário selecionado"}
                    />
                  </FormGroup>,
                ]}
                initialMetadata={shouldPassInitialMetadata ? initialMetadata : undefined}
                shouldPassInitialMetadata={shouldPassInitialMetadata}
                setShouldPassInitialMetadata={setShouldPassInitialMetadata}
                imobiliarioStatus={imobiliarioStatus}
                setImobiliarioStatus={setImobiliarioStatus}
                isDataUpdated={isDataUpdated}
                setIsDataUpdated={setIsDataUpdated}
              >
                {!metadata.formularios && !loading && <FormSkeleton />}

                {metadata.formularios && metadata.id_imobiliario_pessoa && (
                  !metadata.formularios.imobiliario_pessoa?.length ? (
                    <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
                  ) : (
                    <Form formularios={metadata.formularios.imobiliario_pessoa} tabela={"imobiliario_pessoa"} />
                  )
                )}

                {metadata.formularios && (
                  !metadata.formularios.pessoa?.length ? (
                    <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
                  ) : (
                    <Form formularios={metadata.formularios.pessoa} tabela={"pessoa"} />
                  )
                )}
              </Section>
            )}
          {configCaracterizacao &&
            !isPortoPecem &&
            (!("desabilitaEdificacao" in configCaracterizacao) ||
            !configCaracterizacao.desabilitaEdificacao) && (
              <Section
                id="Edificações"
                titulo="Edificações"
                tabela={"edificacao"}
                handleChangeFn={handleChangeEdificacao}
                options={[
                  <Tooltip key={"add-imob-edificacao"} title="Vincular edificação a unidade imobiliária selecionada">
                    <IconButton
                      onClick={handleVincularEdificacao}
                      disabled={isVincularEdificacaoDisabled()}
                    >
                      <LinkIcon />
                    </IconButton>
                  </Tooltip>,

                  <Tooltip
                    key={"del-imob-edificacao"}
                    title="Desvincular edificação de unidade imobiliária selecionada"
                  >
                    <IconButton
                      onClick={handleDesvincularEdificacao}
                      disabled={isDesvincularEdificacaoDisabled()}
                    >
                      <LinkOffIcon />
                    </IconButton>
                  </Tooltip>,
                  <Tooltip key={"open-audit-edificacao"} title="Abrir auditoria da edificação">
                    <IconButton
                      disabled={!metadata.id_edificacao}
                      onClick={() =>
                        metadata.id_edificacao &&
                        openAuditoriaCadastro("edificacao", metadata.id_edificacao, metadata.id_imobiliario_edificacao)
                      }
                    >
                      <ContentPasteSearchIcon />
                    </IconButton>
                  </Tooltip>,
                ]}
                extraOptions={
                  municipio === "riobranco"
                    ? [
                    <Tooltip key={"show-disabled-edificacoes"} title="Exibir edificações desativadas">
                      <Box sx={{ display: "flex" }}>
                        <FormControlLabel
                          checked={showDisabledEdificacoes}
                          onChange={(e: GenericObject) => {
                            setShowDisabledEdificacoes(e.target.checked);
                          }}
                          control={<Checkbox color="default" />}
                          label="Exibir edificações desativadas"
                        />
                      </Box>
                    </Tooltip>,
                    <Tooltip key={"show-edificacoes-sem-vinculos"} title="Exibir edificações sem vínculos">
                      <Box sx={{ display: "flex" }}>
                        <FormControlLabel
                          checked={showEdificacoesSemVinculos}
                          onChange={(e: GenericObject) => {
                            setShowEdificacoesSemVinculos(e.target.checked);
                          }}
                          control={<Checkbox color="default" />}
                          label="Exibir edificações sem vínculos"
                        />
                      </Box>
                    </Tooltip>,
                      ]
                    : undefined
                }
                initialMetadata={shouldPassInitialMetadata ? initialMetadata : undefined}
                shouldPassInitialMetadata={shouldPassInitialMetadata}
                setShouldPassInitialMetadata={setShouldPassInitialMetadata}
                imobiliarioStatus={imobiliarioStatus}
                setImobiliarioStatus={setImobiliarioStatus}
                isDataUpdated={isDataUpdated}
                setIsDataUpdated={setIsDataUpdated}
                configCaracterizacao={configCaracterizacao}
              >
                {!metadata.formularios || loading ? (
                  <FormSkeleton />
                ) : municipio === "riobranco" && !metadata.id_edificacao ? (
                  <Box
                    sx={{
                      backgroundColor: "background.default",
                      color: "text.secondary",
                      px: 2,
                      py: 1.25,
                      borderRadius: 1,
                      fontSize: "0.72rem",
                      fontWeight: 400,
                      wordSpacing: "0.12rem",
                    }}
                  >
                    NENHUMA EDIFICAÇÃO VINCULADA A ESTE IMOBILIÁRIO.
                  </Box>
                ) : !metadata.formularios.imobiliario_edificacao?.length ? (
                  <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
                ) : (
                  <Form formularios={metadata.formularios.imobiliario_edificacao} tabela={"imobiliario_edificacao"} />
                )}
                {municipio === "riobranco" && !metadata.id_edificacao ? null : !metadata.formularios || loading ? (
                  <FormSkeleton />
                ) : !metadata.formularios.edificacao?.length ? (
                  <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
                ) : (
                  <Form formularios={metadata.formularios.edificacao} tabela={"edificacao"} />
                )}
              </Section>
            )}
          {configCaracterizacao &&
            (!("desabilitaMensagens" in configCaracterizacao) ||
            !configCaracterizacao.desabilitaMensagens) && (
              <Section
                id={mensagensSectionTitle}
                titulo={mensagensSectionTitle}
                tabela={"mensagens"}
                handleChangeFn={handleChangeMensagens}
                options={[
                  <Tooltip key={"add-msg"} title="Adicionar mensagem">
                    <IconButton onClick={handleAddMensagem} color="success">
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>,
                  <Tooltip key={"del-msg"} title="Remover mensagem" color="error">
                    <IconButton onClick={handleRemoveMensagem} disabled={!metadata.id_mensagens}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>,
                  <Tooltip key={"open-audit-msg"} title="Abrir auditoria da mensagem">
                    <IconButton
                      disabled={!metadata.id_mensagens}
                      onClick={() => metadata.id_mensagens && openAuditoriaCadastro("mensagens", metadata.id_mensagens)}
                    >
                      <ContentPasteSearchIcon />
                    </IconButton>
                  </Tooltip>,
                ]}
                initialMetadata={shouldPassInitialMetadata ? initialMetadata : undefined}
                shouldPassInitialMetadata={shouldPassInitialMetadata}
                setShouldPassInitialMetadata={setShouldPassInitialMetadata}
                imobiliarioStatus={imobiliarioStatus}
                setImobiliarioStatus={setImobiliarioStatus}
                isDataUpdated={isDataUpdated}
                setIsDataUpdated={setIsDataUpdated}
              >
                {!metadata.formularios || loading ? (
                  <FormSkeleton />
                ) : !metadata.formularios.mensagens?.length ? (
                  <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
                ) : (
                  <Form formularios={metadata.formularios.mensagens} tabela={"mensagens"} />
                )}
              </Section>
            )}

          {configCaracterizacao &&
            (!("desabilitaVisita" in configCaracterizacao) ||
            !configCaracterizacao.desabilitaVisita) && (
              <Section
                id={visitasSectionTitle}
                titulo={visitasSectionTitle}
                tabela={"visitas"}
                handleChangeFn={handleChangeVisitas}
                options={[
                  <Tooltip key={"add-visita"} title="Adicionar visita">
                    <IconButton onClick={handleAddVisita} color="success">
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>,
                  <Tooltip key={"del-vis"} title="Remover visita" color="error">
                    <IconButton onClick={handleRemoveVisita} disabled={!metadata.id_visitas}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>,
                  <Tooltip key={"open-audit-visita"} title="Abrir auditoria da visita">
                    <IconButton
                      disabled={!metadata.id_visitas}
                      onClick={() => metadata.id_visitas && openAuditoriaCadastro("mensagens", metadata.id_visitas)}
                    >
                      <ContentPasteSearchIcon />
                    </IconButton>
                  </Tooltip>,
                ]}
                initialMetadata={shouldPassInitialMetadata ? initialMetadata : undefined}
                shouldPassInitialMetadata={shouldPassInitialMetadata}
                setShouldPassInitialMetadata={setShouldPassInitialMetadata}
                imobiliarioStatus={imobiliarioStatus}
                setImobiliarioStatus={setImobiliarioStatus}
                isDataUpdated={isDataUpdated}
                setIsDataUpdated={setIsDataUpdated}
              >
                {!metadata.formularios || loading ? (
                  <FormSkeleton />
                ) : !metadata.formularios.visitas?.length ? (
                  <Alert severity="info">Nenhum formulário definido nesta seção.</Alert>
                ) : (
                  <Form formularios={metadata.formularios.visitas} tabela={"visitas"} />
                )}
              </Section>
            )}
        </Box>
      </Box>

      <LeftBottomContainer drawer={metadata.drawer}>
        {!isLeitor && (
          <Fab
            sx={{ marginRight: theme.spacing(1) }}
            variant="extended"
            onClick={handleSave}
            color="success"
            disabled={shouldSaveButtonBeDisabled}
          >
            <SaveIcon />
            {!metadata.drawer && <>{!isSaving ? <>&nbsp; Salvar alterações</> : <>&nbsp; Salvando alterações</>}</>}
          </Fab>
        )}
        <Fab
          variant="extended"
          onClick={() =>
            setMetadata((current) => ({
              ...current,
              drawer: !current.drawer,
            }))
          }
          color="primary"
        >
          {metadata.drawer ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </Fab>
      </LeftBottomContainer>

      <DialogSplitImobiliario
        municipio={municipio}
        openDialog={openDialogSplitImobiliario}
        handleCloseDialog={() => setOpenDialogSplitImobiliario(false)}
        fetchAndUpdateDashboardData={fetchAndUpdateDashboardData}
      />
      <DialogJoin
        municipio={municipio}
        openDialog={openDialogJoin}
        handleCloseDialog={() => setOpenDialogJoin(false)}
        fetchAndUpdateDashboardData={fetchAndUpdateDashboardData}
      />
      <DialogPessoa
        municipio={municipio}
        openDialog={openDialogPessoa}
        handleCloseDialog={() => setOpenDialogPessoa(false)}
        onBeforeVinculo={executarComAvisoDebitos}
      />
      <DialogSincronizaPessoa
        municipio={municipio}
        openDialog={openDialogSincronizaPessoa}
        handleCloseDialog={() => setOpenDialogSincronizaPessoa(false)}
      />
      <WarningDialog
        open={openWarningDialog}
        onClose={() => setOpenWarningDialog(false)}
        title="Aviso"
        message={warningMessage}
      />
      <ConfirmDialog
        open={confirmTitularidade.open}
        title="Troca de titularidade"
        message={MENSAGEM_DEBITOS_TITULARIDADE}
        onConfirm={confirmTitularidade.onConfirm}
        onCancel={() => setConfirmTitularidade({ open: false, onConfirm: () => {} })}
      />
      <ConfirmDialog
        open={confirmInativacaoSinter.open}
        title="Confirmar inativação"
        message={confirmInativacaoSinter.message}
        confirmLabel="Confirmar inativação"
        cancelLabel="Cancelar"
        onConfirm={confirmInativacaoSinter.onConfirm}
        onCancel={() => setConfirmInativacaoSinter({ open: false, message: "", onConfirm: () => {} })}
      />
      <DialogVincularEdificacaoRioBranco
        municipio={municipio || ""}
        openDialog={openDialogVincularEdificacaoRioBranco}
        handleCloseDialog={() => setOpenDialogVincularEdificacaoRioBranco(false)}
        onVinculoConcluido={handleVinculoEdificacaoRioBrancoConcluido}
      />
      <DialogVincularMultiImobiliario
        openDialog={openDialogVincularMultiImobiliario || minimized}
        loteId={Number(metadata.id_lote)}
        idPessoa={Number(metadata.id_pessoa)}
        handleCloseDialog={() => {
          setOpenDialogVincularMultiImobiliario(false);
          setMinimized(false);
        }}
        onVinculoConcluido={() => fetchAndUpdateDashboardData(undefined, undefined, true)}
        minimized={minimized}
        setMinimized={setMinimized}
      />
      <WebhookStatusPanel
          socket={socketInstance}
          onRetry={(event) => {
              socketInstance?.emit('startWebhook', {
                  id: event.id,
                  municipio: event.municipio,
                  camada: event.camada,
                  method: event.method,
              });
          }}
      />

      {showModal && <SyncFeedback errorLog={errorLog} showModal={showModal} setShowModal={setShowModal} />}
    </>
  );
}
